// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__327mI","big":"style_big__u8dTJ","shadow":"style_shadow__3JDNk"};